export const ACTION_ITEM_STATUSES = ['active', 'completed', 'deferred'];
export const ACTION_ITEM_RELEVANCES = ['relevant', 'irrelevant', 'unknown'];
export const JOURNEY_CONTEXT_MAX_LENGTH = 300;
export const JOURNEY_STATE_MAX_LENGTH = 500;
export const GOAL_FOCUS_MAX_WORDS = 7;

export const countGoalFocusWords = (value) => {
  const trimmed = String(value || '').trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
};

export const getJourneyDetailsValidation = ({ goalFocus, context }) => {
  const errors = {};
  const goalWordCount = countGoalFocusWords(goalFocus);

  if (!String(goalFocus || '').trim()) {
    errors.goalFocus = 'Add a goal focus.';
  } else if (goalWordCount > GOAL_FOCUS_MAX_WORDS) {
    errors.goalFocus = 'Goal focus must be 7 words or fewer.';
  }

  if (String(context || '').length > JOURNEY_CONTEXT_MAX_LENGTH) {
    errors.context = `Context must be ${JOURNEY_CONTEXT_MAX_LENGTH} characters or fewer.`;
  }

  return errors;
};

const DEFAULT_STATUS = 'active';
const DEFAULT_RELEVANCE = 'unknown';
const DEFAULT_USER_NOTE = '';

const hasAllowedValue = (allowedValues, value) => allowedValues.includes(value);

export const normalizeActionItem = (action) => {
  const base = action && typeof action === 'object' && !Array.isArray(action)
    ? action
    : { value: action };

  return {
    ...base,
    status: hasAllowedValue(ACTION_ITEM_STATUSES, base.status) ? base.status : DEFAULT_STATUS,
    relevance: hasAllowedValue(ACTION_ITEM_RELEVANCES, base.relevance) ? base.relevance : DEFAULT_RELEVANCE,
    user_note: typeof base.user_note === 'string' ? base.user_note : DEFAULT_USER_NOTE,
  };
};

const normalizedString = (value, fallback = '') => (
  typeof value === 'string' ? value : fallback
);

export const getJourneyFramingValidation = (data, { requireRequiredFields = true } = {}) => {
  const base = data && typeof data === 'object' && !Array.isArray(data) ? data : {};
  const startState = normalizedString(base.startState, normalizedString(base.fromTheme));
  const endState = normalizedString(base.endState, normalizedString(base.endTheme));
  const context = normalizedString(base.context);
  const errors = {};

  if (requireRequiredFields && !startState.trim()) {
    errors.startState = 'Add where this Journey starts.';
  }

  if (requireRequiredFields && !endState.trim()) {
    errors.endState = 'Add what successful completion looks like.';
  }

  if (startState.length > JOURNEY_STATE_MAX_LENGTH) {
    errors.startState = `Start must be ${JOURNEY_STATE_MAX_LENGTH} characters or fewer.`;
  }

  if (endState.length > JOURNEY_STATE_MAX_LENGTH) {
    errors.endState = `End must be ${JOURNEY_STATE_MAX_LENGTH} characters or fewer.`;
  }

  if (context.length > JOURNEY_CONTEXT_MAX_LENGTH) {
    errors.context = `Context must be ${JOURNEY_CONTEXT_MAX_LENGTH} characters or fewer.`;
  }

  return errors;
};

export const validateJourneyDataForSave = (data) => {
  const errors = getJourneyFramingValidation(data, { requireRequiredFields: false });
  const firstError = errors.startState || errors.endState || errors.context;

  if (firstError) {
    throw new Error(firstError);
  }
};

export const normalizeJourneyData = (data) => {
  const base = data && typeof data === 'object' && !Array.isArray(data) ? data : {};
  const startState = normalizedString(base.startState, normalizedString(base.fromTheme));
  const endState = normalizedString(base.endState, normalizedString(base.endTheme));
  const context = normalizedString(base.context);

  return {
    ...base,
    fromTheme: startState,
    endTheme: endState,
    startState,
    context,
    endState,
    steps: Array.isArray(base.steps)
      ? base.steps.map((step) => {
        const stepBase = step && typeof step === 'object' && !Array.isArray(step) ? step : {};
        return {
          ...stepBase,
          items: Array.isArray(stepBase.items)
            ? stepBase.items.map(normalizeActionItem)
            : [],
        };
      })
      : [],
  };
};
